import PhonebookMembersDataGrid from './PhonebookMembersDataGrid';

export default PhonebookMembersDataGrid;
